import React from 'react'
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Boton from 'components/boton/Boton';
import Error from 'components/generales/Error';
import { Field, Form, Formik } from 'formik'
import * as Yup from "yup";


const FormularioAhorro = ({ ahorro }) => {
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const nuevoAhorroSchema = Yup.object().shape({
    ahorros: Yup.string(),
    dia: Yup.date().required("Este campo es obligatorio"),
    importe: Yup.number()
      .positive("Importe no válido")
      .typeError("Sólo valores númericos")
      .required("Este campo es obligatorio"),
    concepto: Yup.string().required("Este campo es obligatorio"),
  });

  const handleSubmit = async (valoresMeta) => {
    try {
      const url = "http://localhost:4000/gastos";
      const { status } = await axios.post(url, valoresMeta);
      if (status === 200) {
      }
      navigate("/ahorro/metas");
    } catch (error) {
      setError(true);
      return;
    }
    setError(false);
  };

  return (
    <Formik
      initialValues={{
        ahorros: ahorro?.ahorros ?? "",
        dia: ahorro?.dia ?? "",
        importe: ahorro?.importe ?? "",
        concepto: ahorro?.concepto,
      }}
      onSubmit={async (values, { resetForm }) => {
        await handleSubmit(values);
        resetForm();
      }}
      validationSchema={nuevoAhorroSchema}
    >
      {({ errors, touched }) => {
        return (
          <Form>
            <div className="formulario-input">
              <label htmlFor="ahorros">Ahorros</label>
              <Field component="select" id="ahorros" name="ahorros">
                <option value="">Elige el tipo de ahorro</option>
                <option value="Viaje">Viaje</option>
                <option value="Pago">Pago</option>
                <option value="Deudas">Deudas</option>
                <option value="Enganche">Enganche</option>
              </Field>
              {errors.ahorros && touched.ahorros ? (
                <Error>{errors.ahorros}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="dia">Dia de registro</label>
              <Field
                id="dia"
                type="date"
                value="2022-01-01"
                name="dia"
              />
              {errors.dia && touched.dia ? (
                <Error>{errors.dia}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="importe">Importe</label>
              <Field
                id="importe"
                type="number"
                placeholder="$ "
                name="importe"
              />
              {errors.importe && touched.importe ? (
                <Error>{errors.importe}</Error>
              ) : null}
            </div>

            <div className="formulario-input">
              <label htmlFor="concepto">Concepto</label>
              <Field
                id="concepto"
                type="number"
                placeholder="Concepto de ahorro"
                name="concepto"
              />
              {errors.concepto && touched.concepto ? (
                <Error>{errors.concepto}</Error>
              ) : null}
            </div>
            <Boton>Guardar</Boton>
          </Form>
        )
      }}
    </Formik>
  )
}

export default FormularioAhorro